import storeManager from '../../store/StoreManager';
import settingsReader from './SettingsReader';
import objectTypes from '../../constants/ObjectTypes';

export const UIProperty = {
    SECTION_PART_PREFIX: 'footer__sectionPartPrefix',
    SHOW_DYNAMIC_RUBRIC: 'rubric__showDynamicRubric',
    SHOW_QUESTION_COPYRIGHT_TEXT: 'question__showCopyrightText',
    SHOW_QUESTION_RUBRIC: 'rubric__showQuestionRubric',
    SHOW_SECTION_RUBRIC: 'rubric__showSectionRubric',
    SHOW_STIMULUS_MARGINS: 'stimulus__showMargins',
    SUPPORTS_GAP_MATCH_SPLIT_SCROLLING: 'gapMatchExtended__supportsSplitScrolling',
    SUPPORTS_INTERACTION_IMAGE_SCALING: 'question__supportsInteractionImageScaling',
};

const uiReader = {
    isTimeRemainingHidden(ui, settings) {
        const { timeRemainingHidden } = ui || storeManager.getState().ui;
        return timeRemainingHidden
            || settingsReader.isTimeRemainingHidden(settings || storeManager.getState().settings);
    },

    useBackgroundAudioOverlay() {
        const { useBackgroundAudioOverlay, backgroundAudioStarted, backgroundAudioCanceled } = storeManager.getState().ui;
        return useBackgroundAudioOverlay && !backgroundAudioStarted && !backgroundAudioCanceled;
    },

    getMarketplaceTheme(ui = storeManager.getState().ui) {
        return ui.marketplaceTheme;
    },

    getThemeVariableValue(themeVariable, ui = storeManager.getState().ui) {
        return ui.variables[themeVariable];
    },

    showSectionPartPrefix() {
        return !!this.getThemeVariableValue(UIProperty.SECTION_PART_PREFIX);
    },

    showQuestionRubric() {
        return !!this.getThemeVariableValue(UIProperty.SHOW_QUESTION_RUBRIC);
    },

    showDynamicRubric() {
        return !!this.getThemeVariableValue(UIProperty.SHOW_DYNAMIC_RUBRIC);
    },

    showSectionRubric() {
        return !!this.getThemeVariableValue(UIProperty.SHOW_SECTION_RUBRIC);
    },

    supportsSplitScrolling() {
        return !!this.getThemeVariableValue(UIProperty.SUPPORTS_GAP_MATCH_SPLIT_SCROLLING);
    },

    supportsInteractionImageScaling() {
        return !!this.getThemeVariableValue(UIProperty.SUPPORTS_INTERACTION_IMAGE_SCALING);
    },

    showQuestionCopyrightText() {
        return !!this.getThemeVariableValue(UIProperty.SHOW_QUESTION_COPYRIGHT_TEXT);
    },

    showStimulusMargins() {
        return !!this.getThemeVariableValue(UIProperty.SHOW_STIMULUS_MARGINS);
    },

    interactionSupportsRTL(objectType) {
        return [
            objectTypes.INLINE_CHOICE,
            objectTypes.MULTIPLE_CHOICE,
            objectTypes.MULTIPLE_RESPONSE,
            objectTypes.TEXT_ENTRY,
        ].includes(objectType);
    },

    isAnsweredQuestionsAutocommitEnabled() {
        const { ui } = storeManager.getState();
        return !!ui.shouldAutocommitAnsweredQuestions;
    },

    isOwnPreviewEnabled() {
        const { ui } = storeManager.getState();
        return !!ui.isOwnPreviewEnabled;
    },
};

export default uiReader;
